// Service catalog used to generate per-city repair-service landing pages.
// Adding a service here automatically creates a landing page at /<slug>/:cityState.

export const SERVICE_PAGES = {
  'phone-repair': {
    name: 'Phone Repair',
    headline: 'Phone Repair',
    tag: 'Cracked screen? Dead battery? We fix it.',
    intro: 'Same-day phone repair on most makes and models — iPhone, Samsung Galaxy, Pixel, OnePlus, and more. Walk in, drop off, or schedule online. Every repair is backed by a 90-day warranty.',
    bullets: [
      'iPhone & Android screen replacement',
      'Battery replacement on most models',
      'Charging port, speaker, and mic repair',
      'Water damage diagnostics',
      'Back-glass and frame repair',
    ],
    schemaName: 'Mobile Phone Repair',
    priceRange: '$$',
  },
  'iphone-repair': {
    name: 'iPhone Repair',
    headline: 'iPhone Repair',
    tag: 'Genuine-quality parts. 90-day warranty. Often done in under an hour.',
    intro: 'Local iPhone repair for every model — from the iPhone 8 to the latest Pro Max. Screen replacement, battery, charging port, camera, and back glass — all done same-day in most cases.',
    bullets: [
      'iPhone screen & LCD/OLED replacement',
      'iPhone battery replacement',
      'Charging port & lightning connector',
      'Front and rear camera repair',
      'Back-glass replacement',
      'Water damage cleaning',
    ],
    schemaName: 'iPhone Repair Service',
    priceRange: '$$',
  },
  'samsung-repair': {
    name: 'Samsung Repair',
    headline: 'Samsung Galaxy Repair',
    tag: 'OEM-grade parts for every Galaxy series.',
    intro: 'Galaxy S, Note, A-series, and Z Fold/Flip repairs. Most fixes are same-day with a 90-day warranty.',
    bullets: [
      'Galaxy screen replacement (OLED)',
      'Battery & charging port repair',
      'Back-glass replacement',
      'Camera and speaker repair',
      'Fold/Flip hinge service',
    ],
    schemaName: 'Samsung Galaxy Repair',
    priceRange: '$$',
  },
  'screen-repair': {
    name: 'Screen Repair',
    headline: 'Phone & Tablet Screen Repair',
    tag: 'Most screens replaced in under an hour.',
    intro: 'Cracked, shattered, or unresponsive? We stock screens for every popular iPhone, Samsung, Pixel, and iPad in store. Same-day service backed by a 90-day warranty.',
    bullets: [
      'iPhone screen replacement',
      'Samsung Galaxy OLED replacement',
      'Google Pixel screen repair',
      'iPad and tablet glass + LCD',
      'Touch digitizer repair',
    ],
    schemaName: 'Phone Screen Replacement',
    priceRange: '$$',
  },
  'battery-replacement': {
    name: 'Battery Replacement',
    headline: 'Phone, Tablet & Laptop Battery Replacement',
    tag: 'Bring your old device back to life.',
    intro: 'Phone dying by lunchtime? Tablet draining overnight? We replace batteries on iPhones, Samsung Galaxy, iPads, MacBooks, and laptops with high-cycle, OEM-grade cells.',
    bullets: [
      'iPhone battery replacement',
      'Galaxy & Pixel batteries',
      'iPad and tablet batteries',
      'MacBook batteries (all generations)',
      'PC laptop batteries',
    ],
    schemaName: 'Battery Replacement Service',
    priceRange: '$',
  },
  'tablet-repair': {
    name: 'Tablet Repair',
    headline: 'iPad & Tablet Repair',
    tag: 'All iPad generations + Galaxy Tab, Surface, and Fire tablets.',
    intro: 'Cracked iPad screen, dead tablet battery, or charging port issues? We service every major tablet brand with same-day turnarounds on most jobs.',
    bullets: [
      'iPad screen replacement (all gens)',
      'Galaxy Tab repair',
      'Surface Pro repair',
      'Battery replacement',
      'Charging port repair',
      'Home button / Touch ID repair',
    ],
    schemaName: 'Tablet & iPad Repair',
    priceRange: '$$',
  },
  'computer-repair': {
    name: 'Computer Repair',
    headline: 'Computer & Laptop Repair',
    tag: 'Mac, PC, gaming rigs — hardware and software.',
    intro: 'Slow laptop? Cracked MacBook screen? Virus or stuck-on-the-Apple-logo issues? Our certified techs handle everything from hardware swaps to OS reinstalls.',
    bullets: [
      'MacBook & PC screen replacement',
      'Keyboard, trackpad, hinges',
      'SSD upgrades, RAM upgrades',
      'Virus & malware removal',
      'Data recovery',
      'Liquid-damage cleaning',
    ],
    schemaName: 'Computer Repair Service',
    priceRange: '$$',
  },
  'game-console-repair': {
    name: 'Game Console Repair',
    headline: 'Game Console Repair',
    tag: 'PlayStation, Xbox, Nintendo Switch — fixed by gamers, for gamers.',
    intro: 'Overheating, HDMI port broken, controller drift, disc drive failure? We repair every modern console with a 90-day warranty.',
    bullets: [
      'PS5 / PS4 HDMI port repair',
      'Xbox Series X|S / One repair',
      'Nintendo Switch joycon & screen repair',
      'Console overheating cleaning',
      'Controller drift / button repair',
    ],
    schemaName: 'Game Console Repair',
    priceRange: '$$',
  },
};

export const SERVICE_SLUGS = Object.keys(SERVICE_PAGES);
